import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ClearBuildCacheIcon = (props: WrappingIconProps) => {
  return (
    <Icon fill="none" {...props}>
      <path
        d="M13.5 4.5H10.5C10.2239 4.5 10 4.72386 10 5V8H5C4.72386 8 4.5 8.22386 4.5 8.5V11C4.5 11.2761 4.72386 11.5 5 11.5H19C19.2761 11.5 19.5 11.2761 19.5 11V8.5C19.5 8.22386 19.2761 8 19 8H14V5C14 4.72386 13.7761 4.5 13.5 4.5Z"
        stroke="currentcolor"
        strokeWidth="2"
      />
      <path
        d="M5.5 12C5.53965 14.5344 5.36135 16.0959 4.83402 18.23C4.67557 18.8712 5.15257 19.5 5.81313 19.5H18.2229C18.8723 19.5 19.3477 18.8907 19.2038 18.2574C18.7111 16.0901 18.5104 14.5218 18.5 12"
        stroke="currentcolor"
        strokeWidth="2"
      />
      <path
        d="M9.5 15V19M14.5 15V19"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};
